<template>
  <div>
    <div class="fullpage-container" @wheel="handleWheel">
      <div 
        class="fullpage-wrapper" 
        :style="{ transform: `translateY(-${currentIndex * 100}vh)` }"
      >
        <!-- 第一屏 -->
        <section class="fullpage-section section-1" >
          <div class="section-content_1">
            <img class="topBT" src="@/assets/img/home/top_b.png" alt="">
            <!-- <img class="topBigCenter" 
              src="@/assets/img/home/carbonneBigCenter.png" 
              alt=""
            > -->
            <div class="section-1_top">
              <div class="section-1_top_title">碳行 丨 重塑双碳行业服务范式</div>
              <div class="section-1_top_desc">碳行将碳知方案落地为可执行的产品与服务，通过自有Agent工具、定制化解决方案与第三方生态协同，实现能力统一调度与按需匹配，构建可持续扩展的双碳服务网络</div>
              <div class="section-1_top_btn">
                <div class="section-1_top_btn_item" @click="gotoWeb">立即体验</div>
              </div>
            </div>
            <div class="section-1_bottom">
              <img class="section-1_bottom_img" src="@/assets/img/home/section-1_bottom_img_sustainability.png">
            </div>
          </div>
        </section>
        
        <!-- 第三屏 -->
        <section class="fullpage-section section-3">
          <div class="section-3-container" :class="{ 'scrollable': currentIndex === 2 }">
            <!-- SVG 覆盖层，用于绘制连线 -->
            <svg class="connections-svg" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="none"></svg>
            <div class="section-3-content">
              <div class="section-3-content_1">
                <div class="section-3-content_1_back"></div>
                <img class="icon1" src="@/assets/img/home/section-3-content_1_t_icon1.png" alt="">
                <img class="icon2" src="@/assets/img/home/section-3-content_1_t_icon2.png" alt="">
                <img class="icon3" src="@/assets/img/home/section-3-content_1_t_icon3.png" alt="">
                <img class="icon4" src="@/assets/img/home/section-3-content_1_t_icon4.png" alt="">
                <img class="icon5" src="@/assets/img/home/section-3-content_1_t_icon5.png" alt="">
                <img class="icon6" src="@/assets/img/home/section-3-content_1_t_icon6.png" alt="">
                <img class="icon7" src="@/assets/img/home/section-3-content_1_t_icon7.png" alt="">
                <img class="icon8" src="@/assets/img/home/section-3-content_1_t_icon8.png" alt="">
                <img class="icon9" src="@/assets/img/home/section-3-content_1_t_icon9.png" alt="">
                <img class="icon10" src="@/assets/img/home/section-3-content_1_t_icon10.png" alt="">
                <!--不一样-->
                <img class="icon1_1" src="@/assets/img/home/section-3-content_1_t_icon1_native.png" alt="">
                <img class="icon1_2" src="@/assets/img/home/section-3-content_1_t_icon2_native.png" alt="">
                <img class="icon1_3" src="@/assets/img/home/section-3-content_1_t_icon3_native.png" alt="">
                <img class="icon1_4" src="@/assets/img/home/section-3-content_1_t_icon4_native.png" alt="">
                <img class="icon1_5" src="@/assets/img/home/section-3-content_1_t_icon5_native.png" alt="">
                <img class="icon1_6" src="@/assets/img/home/section-3-content_1_t_icon6_native.png" alt="">
                <img class="icon1_7" src="@/assets/img/home/section-3-content_1_t_icon7_native.png" alt="">
                <img class="icon1_8" src="@/assets/img/home/section-3-content_1_t_icon8_native.png" alt="">
                <img class="icon1_9" src="@/assets/img/home/section-3-content_1_t_icon9_native.png" alt="">
                <img class="icon1_10" src="@/assets/img/home/section-3-content_1_t_icon10_native.png" alt="">
                <div class="section-3-content_1_t">
                  <div class="section-3-content_1_t_title">全栈AI双碳产品</div>
                  <div class="section-3-content_1_t_title">服务矩阵</div>
                  <div class="section-3-content_1_t_desc"> 三大核心体系，覆盖双碳全生命周期服务</div>
                  <img class="section-3-content_1_t_img" src="@/assets/img/home/section-3-content_1_t_img.png" alt="">
                </div>
                <div class="section-3-content_1_b">
                  <div class="section-3-content_1_b_title">按需定制适配</div>
                  <div class="section-3-content_1_b_title">精准匹配不同主体双碳需求</div>
                </div>
                <div class="info_view">
                  <div class="info_view_item" 
                    :class="{'info_public': itemIndex === 1}"
                    @click="handClick(1)"
                  >
                    <img v-if="itemIndex != 1" src="@/assets/img/home/icon_push.png" alt="">
                    <div v-if="itemIndex != 1">企业案例</div>
                    <div class="info_view_item_view" v-if="itemIndex == 1"><span>企业案例</span>｜<span>某国有大型发电集团</span>：该集团下属十余家电厂碳排放源多、数据链条长，传统人工碳盘查周期长达30天、人力投入大、数据错漏率高，同时面临央企ESG披露、碳履约、绿色融资多重压力。我方为其部署<span>双碳垂类大语言模型</span>，完成集团碳管理系统全维度AI化升级，落地碳盘查、ESG全系列AI Agent，打通生产、能耗、财务全量数据。项目落地后，集团整体碳盘查效率提升90%以上，核算准确率提升至95%，年度碳管理人力成本降低80%，顺利完成全集团ESG合规披露，助力企业成功落地多项绿色信贷与碳资产增值项目，实现碳管理从数字化台账向AI智能决策的跨越式升级。</div>
                  </div>
                  <div class="info_view_item" 
                    :class="{'info_public': itemIndex === 2}" 
                    @click="handClick(2)"
                  >
                    <img v-if="itemIndex != 2" src="@/assets/img/home/icon_push.png" alt="">
                    <div v-if="itemIndex != 2">公共机构案例</div>
                    <div class="info_view_item_view" v-if="itemIndex == 2"><span>公共机构案例</span>｜<span>某省级政务服务中心</span>：该政务中心建筑面积大、用能设备繁杂，长期存在碳排放底数不清、能耗监管粗放、年度碳盘查依赖外包、节能改造无数据支撑等问题。我方为其接入<span>碳盘查AI Agent</span>并配套部署建筑能碳管控平台，实现水电热气能耗与碳排放数据实时核算、自动归集、一键申报。项目落地后，彻底告别传统人工统计模式，盘查周期由7天压缩至小时级，精准识别15项高耗能优化点位，落地节能改造后实现年度节电30万度、年减碳230余吨，100%达标省级公共机构节能考核要求。</div>
                  </div>
                  <div class="info_view_item" 
                    :class="{'info_public': itemIndex === 3}" 
                    @click="handClick(3)"
                  >
                    <img v-if="itemIndex != 3" src="@/assets/img/home/icon_push.png" alt="">
                    <div v-if="itemIndex != 3">产业园区案例</div>
                    <div class="info_view_item_view" v-if="itemIndex == 3"><span>产业园区案例</span>｜<span>某国家级经开区工业园区</span>：园区入驻企业超百家、行业业态分散，存在能耗碳排数据碎片化、监管盲区多、零碳创建无体系、企业双碳赋能不足等痛点。我方为园区搭建AI赋能的<span>能碳管控平台+零碳园区管理平台</span>，配套上线碳普惠平台与全系列AI Agent工具，构建园区一体化能碳智能管理体系。项目落地后，实现园区企业碳排能耗100%全覆盖监测，异常能耗预警响应效率提升95%，园区综合能耗降低17%，成功获评省级零碳试点园区，大幅提升园区绿色招商核心竞争力。</div>
                  </div>
                  <div class="info_view_item" 
                    :class="{'info_public': itemIndex === 4}" 
                    @click="handClick(4)"
                  >
                    <img v-if="itemIndex != 4" src="@/assets/img/home/icon_push.png" alt="">
                    <div v-if="itemIndex != 4">政府案例</div>
                    <div class="info_view_item_view" v-if="itemIndex == 4"><span>政府案例</span>｜<span>某地级市发改、生态环境局</span>：当地存在区域碳底数模糊、行业碳数据割裂、减排目标难以精准分解、全民低碳氛围薄弱等治理难题。我方依托<span>双碳垂类大语言模型</span>，为当地搭建区域双碳治理体系，落地城市级碳普惠平台，配套完成零碳区域顶层规划与年度减排方案编制。项目落地后，实现全市重点用能企业碳排数据100%动态监管，减排目标精准分解至各区县、各行业，重点减排项目落地率提升45%，成功构建“政府监管、企业落实、全民参与”的全域双碳治理新格局。</div>
                  </div>
                  <div class="info_view_item" 
                    :class="{'info_public': itemIndex === 5}" 
                    @click="handClick(5)"
                  >
                    <img v-if="itemIndex != 5" src="@/assets/img/home/icon_push.png" alt="">
                    <div v-if="itemIndex != 5">个人用户案例</div>
                    <div class="info_view_item_view" v-if="itemIndex == 5"><span>个人用户案例</span>｜<span>城市全域市民/园区职工</span>：针对大众低碳行为无量化、无激励、参与度低的普遍问题，依托<span>碳普惠平台</span>搭建个人碳账户体系，自动归集绿色出行、居家节能、垃圾分类等全场景低碳行为数据，智能换算碳积分并开放多元权益兑换。平台上线后，累计服务市民及园区用户超12万人，日均低碳行为记录超6万次，有效带动区域绿色出行率提升22%，成功激活全民低碳参与活力，夯实城市低碳生态建设基础。</div>
                  </div>
                </div>
              </div>
              <div class="section-3-content_2">
                <img class="section-3-content_2_img" src="@/assets/img/home/section-3-content_2_img.png" alt="">
                <div class="section-3-content_2_r">
                  <div class="section-3-content_2_r_title">解锁碳中和的无限扩展可能</div>
                  <div class="section-3-content_2_r_view">
                    <div class="section-3-content_2_r_view_item" :class="{'active': chooseIndex === 1}" @click="chooseItem(1)">
                      <img class="section-3-content_2_r_view_item_img" v-if="chooseIndex === 1" src="@/assets/img/home/section-3-content_2_r_view_item_img_1.png" alt="">
                      <img class="section-3-content_2_r_view_item_img" v-else src="@/assets/img/home/section-3-content_2_r_view_item_img_1_active.png" alt="">
                    </div>
                    <div class="section-3-content_2_r_view_item" :class="{'active': chooseIndex === 2}" @click="chooseItem(2)">
                      <img class="section-3-content_2_r_view_item_img" v-if="chooseIndex === 2" src="@/assets/img/home/section-3-content_2_r_view_item_img_2.png" alt="">
                      <img class="section-3-content_2_r_view_item_img" v-else src="@/assets/img/home/section-3-content_2_r_view_item_img_2_active.png" alt="">
                    </div>
                    <div class="section-3-content_2_r_view_item" :class="{'active': chooseIndex === 3}" @click="chooseItem(3)">
                      <img class="section-3-content_2_r_view_item_img" v-if="chooseIndex === 3" src="@/assets/img/home/section-3-content_2_r_view_item_img_3.png" alt="">
                      <img class="section-3-content_2_r_view_item_img" v-else src="@/assets/img/home/section-3-content_2_r_view_item_img_3_active.png" alt="">
                    </div>
                    <div class="section-3-content_2_r_view_item" :class="{'active': chooseIndex === 4}" @click="chooseItem(4)">
                      <img class="section-3-content_2_r_view_item_img_other" v-if="chooseIndex === 4" src="@/assets/img/home/section-3-content_2_r_view_item_img_4.png" alt="">
                      <img class="section-3-content_2_r_view_item_img_other" v-else src="@/assets/img/home/section-3-content_2_r_view_item_img_4_active.png" alt="">
                    </div>
                  </div>
                  <template v-if="chooseIndex === 1">
                    <div class="section-3-content_2_r_text1">让专业能力普惠化</div>
                    <div class="section-3-content_2_r_text2">让复杂的双碳知识与专业服务，不再局限于少数专家。</div>
                  </template>
                  <template v-if="chooseIndex === 2">
                    <div class="section-3-content_2_r_text1">让能力形成矩阵</div>
                    <div class="section-3-content_2_r_text2">通过 AI Agent、能碳平台和绿色生态服务，覆盖碳盘查、碳足迹、ESG、碳普惠等核心场景。</div>
                  </template>
                  <template v-if="chooseIndex === 3">
                    <div class="section-3-content_2_r_text1">让服务精准匹配</div>
                    <div class="section-3-content_2_r_text2">面向企业、园区、政府、公共机构和个人用户，提供更适配的双碳产品与服务组合。</div>
                  </template>
                  <template v-if="chooseIndex === 4">
                    <div class="section-3-content_2_r_text1">让生态持续扩展</div>
                    <div class="section-3-content_2_r_text2">连接咨询机构、技术服务商、设备厂商等伙伴，形成开放协同的双碳服务网络。</div>
                  </template>
                </div>
              </div>
              <!-- <div class="section-3-content_3">
                <div class="section-3-content_3_btn">
                  <div class="section-3-content_3_btn_l">
                    <img class="section-3-content_3_btn_img" src="@/assets/img/home/section-3-content_3_btn_l_img.png" alt="">
                  </div>
                  <div class="section-3-content_3_btn_r" @click="gotoWeb">
                    <img class="section-3-content_3_btn_img" src="@/assets/img/home/section-3-content_3_btn_img.png" alt="">
                  </div>
                </div>
              </div> -->
            </div>
            <Footer/>
          </div>
        </section>
      </div>
    </div>
  </div>
</template>

<script>
import PCNavbar from '@/components/navbar/index'
import MobileNavBar from '@/components/navbar/MobileNavBar.vue'
import Footer from '@/components/footer/index'

export default {
  components: {
    PCNavbar,
    MobileNavBar,
    Footer
  },
  data() {
    return {
      currentIndex: 0, // 当前屏幕索引
      isScrolling: false, // 是否正在滚动中
      sections: 2, // 总屏幕数量
      transitionDuration: 1500, // 过渡动画时间（毫秒），这里改为1秒
      isSection3Scrolling: false, // 第三屏内部是否正在滚动
      section3ScrollPosition: 0, // 第三屏内部滚动位置
      isChatScrolling: false,
      isBtnActive: 1,
      scrollProgress: 0, // 滚动进度，用于动画计算
      itemIndex: 1, // 当前案例索引
      overlayContentMap: {
        3: { title: '碳盘查', desc: '全球首款双碳领域AI Agent工具，颠覆性的依托自研垂类大模型+Agent帮助企业高效、精准、低成本的完成碳排放核算与报告生成工作' },
        8: { title: 'ESG报告', desc: '打造从数据治理、内容生成到合规审阅的AI Agent闭环。将ESG报告编制的复杂逻辑智能化、自动化，助力企业以极低成本完成高质量ESG信息披露，让可持续发展故事触手可及' },
        9: { title: '碳足迹', desc: '全球首款双碳领域AI Agent工具，颠覆性的依托自研垂类大模型+Agent帮助企业高效、精准、低成本的完成碳排放核算与报告生成工作' },
        4: { title: 'CBMA', desc: '深度嵌入欧盟最新CBAM实施细则及默认值数据库。自动解析企业生产工序、能耗数据及物料流，精准完成隐含碳排放的量化核算与数据填报，智能生成符合欧盟进口商要求的CBAM报告' },
        10: { title: '双碳知识库', desc: '碳管理领域专业知识库，整合政策法规、行业标准、技术指南、案例研究等核心内容，为用户提供权威、系统的碳管理知识支持，助力决策与实践' },
        5: { title: '碳资产', desc: '一款面向控排企业、碳资产持有方及投资机构的专业化管理平台，提供碳配额与核证减排量的全生命周期管理能力。平台涵盖碳资产台账登记、履约预测等功能模块，支持企业实时掌握碳资产存量、履约缺口及市场动态。通过系统化的资产管理与数据支撑，帮助企业规范碳资产运营，提升碳资产价值' },
        1: { title: '零碳园区', desc: '依托公司团队在低碳园区领域的实践经验，为各类产业园区提供全过程支持，服务内容包括园区碳排放基线核算、减排路径设计、零碳创建方案编制、申报材料准备及评审配合等环节，严格遵循国家及地方关于零碳/近零碳园区试点的相关要求与评价标准' },
        2: { title: '能碳平台', desc: '一款面向工业企业、园区及公共机构的能源与碳排放管理软件，为企业提供能耗监测、碳核算分析及能效优化的综合管理能力。系统支持多源数据接入，实现能源消耗与碳排放数据的统一管理与关联分析。平台提供数据看板、能耗趋势分析、排放强度对标及报表生成等功能，帮助企业建立常态化的能碳管理体系' },
        6: { title: '绿色金融评估认证', desc: '依托银行在绿色信贷领域的专业团队与风控体系，为企业绿色项目提供融资审批全流程支持。服务涵盖绿色项目识别、环境效益评估、合规性审查、授信方案设计及贷后管理建议等环节，协助企业规范融资材料，助力绿色低碳产业健康发展' },
        7: { title: '低碳/零碳', desc: '面向地方政府、园区管委会及片区开发主体，围绕国家级及省级低碳园区、零碳示范区等试点创建工作要求，严格遵循国家及地方关于低碳/零碳试点创建的相关政策与评价标准，提供从试点申报、方案编制到创建实施、验收评估的全流程专业支持' }
      },
      // 定义每个 info item 对应需要连线的 icons 列表
      connectionsMap: {
        1: ['icon4','icon7','icon9'],
        2: ['icon2','icon10'],
        3: ['icon3','icon6'],
        4: ['icon5','icon7', 'icon8'],
        5: ['icon1','icon6']
      },
      chooseIndex: 1,
    };
  },
  mounted() {
    this.addTrackpadSupport();
    this.initIconAnimation();
    this.initConnections();
    this.initIconOverlay();
    this.$emit('current-index-change', this.currentIndex);
    this.$emit('section-3-scroll-top-change', 0);
  },
  destroyed() {
    this.removeTrackpadSupport();
    this.cleanup();
  },
  methods: {
    chooseItem(index) {
      this.chooseIndex = index
    },
    gotoWeb() {
      this.gotoWebSite()
    },
    /**
     * 添加触摸板支持
     */
    addTrackpadSupport() {
      // 监听触摸板手势
      document.addEventListener('wheel', this.handleWheel, { passive: false });
    },
    
    /**
     * 移除触摸板支持
     */
    removeTrackpadSupport() {
      document.removeEventListener('wheel', this.handleWheel);
    },
    /**
     * 处理鼠标滚轮和触摸板事件
     */
    handleWheel(e) {
      // 如果正在滚动中，则忽略后续滚轮事件
      if (this.isScrolling) return;

      // 如果聊天容器正在滚动，忽略全屏滚动
      if (this.isChatScrolling) return;

      // 如果在第三屏，优先处理内部滚动
      if (this.currentIndex === 1) {
        this.handleSection3Scroll(e);
        return;
      }

      // 对于非第三屏，阻止默认行为并处理全屏切换
      e.preventDefault();

      // 全屏切换逻辑
      if (e.deltaY > 0) {
        this.nextSection();
      } else {
        this.prevSection();
      }
    },

    /**
     * 处理第三屏内部滚动
     */
    handleSection3Scroll(e) {
      const section3Container = document.querySelector('.section-3-container');
      if (!section3Container) return;
      const container = section3Container;
      const scrollTop = container.scrollTop;
      const clientHeight = container.clientHeight;
      const scrollHeight = container.scrollHeight;
      
      // 计算滚动进度
      const maxScroll = scrollHeight - clientHeight;
      if (maxScroll > 0) {
        this.scrollProgress = Math.min(scrollTop / maxScroll, 1);
        this.updateIconAnimation();
      }
      
      // 计算滚动方向
      const isScrollingDown = e.deltaY > 0;
      
      // 检查是否在边界（使用更大的容差）
      const isAtTop = scrollTop <= 10;
      const isAtBottom = scrollTop + clientHeight >= scrollHeight - 10;
      
      // 如果不在边界，允许自然滚动（不阻止默认行为）
      if ((isScrollingDown && !isAtBottom) || (!isScrollingDown && !isAtTop)) {
          // 不阻止默认行为，让浏览器处理自然滚动
        return;
      }
      
      // 如果在边界，阻止默认行为并处理全屏切换
      e.preventDefault();
      
      if ((isScrollingDown && isAtBottom) || (!isScrollingDown && isAtTop)) {
        if (isScrollingDown) {
          this.nextSection();
        } else {
          this.prevSection();
        }
      }
    },

    /**
     * 滚动到下一屏
     */
    nextSection() {
      if (this.currentIndex < this.sections - 1) {
        this.startScroll(this.currentIndex + 1);
      }
    },

    /**
     * 滚动到上一屏
     */
    prevSection() {
      if (this.currentIndex > 0) {
        this.startScroll(this.currentIndex - 1);
      }
    },

    /**
     * 开始滚动动画
     */
    startScroll(index) {
      this.isScrolling = true;
      this.currentIndex = index;
      this.$emit('current-index-change', this.currentIndex);
      
      // 滚动动画结束后重置状态
      setTimeout(() => {
          this.isScrolling = false;
      }, this.transitionDuration);
    },
    
    /**
     * 处理第三屏内部滚动
     */
    handleSection3Scroll(e) {
      const section3Container = document.querySelector('.section-3-container');
      if (!section3Container) return;
      const container = section3Container;
      const scrollTop = container.scrollTop;
      const clientHeight = container.clientHeight;
      const scrollHeight = container.scrollHeight;
      
      // 计算滚动进度
      const maxScroll = scrollHeight - clientHeight;
      if (maxScroll > 0) {
        this.scrollProgress = Math.min(scrollTop / maxScroll, 1);
        this.updateIconAnimation();
      }
      
      // 计算滚动方向
      const isScrollingDown = e.deltaY > 0;
      
      // 检查是否在边界（使用更大的容差）
      const isAtTop = scrollTop <= 10;
      const isAtBottom = scrollTop + clientHeight >= scrollHeight - 10;
      
      // 如果不在边界，允许自然滚动（不阻止默认行为）
      if ((isScrollingDown && !isAtBottom) || (!isScrollingDown && !isAtTop)) {
          // 不阻止默认行为，让浏览器处理自然滚动
        return;
      }
      
      // 如果在边界，阻止默认行为并处理全屏切换
      e.preventDefault();
      
      if ((isScrollingDown && isAtBottom) || (!isScrollingDown && isAtTop)) {
        if (isScrollingDown) {
          this.nextSection();
        } else {
          this.prevSection();
        }
      }
    },
    
    /**
     * 初始化图标动画
     */
    initIconAnimation() {
      // 确保DOM元素已渲染后进行初始化
      this.$nextTick(() => {
        const section3Container = document.querySelector('.section-3-container');
        if (section3Container) {
          // 使用绑定后的引用，便于 later remove
          this._handleSection3ScrollRealTime = this.handleSection3ScrollRealTime.bind(this);
          this._updateConnectionsForScroll = this.updateConnections.bind(this);
          // 监听滚动事件以触发动画
          section3Container.addEventListener('scroll', this._handleSection3ScrollRealTime);
          // 监听滚动以更新连线
          section3Container.addEventListener('scroll', this._updateConnectionsForScroll);
        }
      });
    },

    /**
     * 点击切换案例
     */
    handClick(index) {
      this.itemIndex = index;
      this.$nextTick(() => {
        this.updateConnections();
      });
    },

    /**
     * 初始化图标覆盖层
     */
    initIconOverlay() {
      this.$nextTick(() => {
        const container = document.querySelector('.section-3-content_1');
        if (!container) return;

        // 创建覆盖层 div
        let overlay = document.createElement('div');
        overlay.className = 'icon-overlay';
        overlay.innerHTML = `
          <div class="icon-overlay-content">
            <div class="icon-overlay-title"></div>
            <div class="icon-overlay-desc"></div>
          </div>
        `;
        container.appendChild(overlay);

        const titleEl = overlay.querySelector('.icon-overlay-title');
        const descEl = overlay.querySelector('.icon-overlay-desc');

        // 为 icon1-icon10 添加鼠标事件
        for (let i = 1; i <= 10; i++) {
          const icon = document.querySelector(`.icon${i}`);
          if (icon) {
            icon.addEventListener('mouseenter', () => {
              const rect = icon.getBoundingClientRect();
              const containerRect = container.getBoundingClientRect();
              const content = this.overlayContentMap[i] || { title: '双碳方案', desc: '查看更多智能服务能力' };

              if (titleEl) titleEl.textContent = content.title;
              if (descEl) descEl.textContent = content.desc;

              // 设置 overlay 位置为图标中心（配合 CSS transform: translate(-50%, -50%) 实现完美居中）
              overlay.style.left = `${rect.left - containerRect.left + rect.width / 2}px`;
              overlay.style.top = `${rect.top - containerRect.top + rect.height / 2}px`;
              overlay.classList.add('visible');
            });

            icon.addEventListener('mouseleave', () => {
              overlay.classList.remove('visible');
            });
          }
        }
      });
    },

    /**
     * 初始化连线 SVG
     */
    initConnections() {
      this.$nextTick(() => {
        const container = document.querySelector('.section-3-container');
        const svg = container && container.querySelector('.connections-svg');
        if (!container || !svg) return;

        // 根据 connectionsMap 创建需要的 path 元素（一次性创建，后续显示/隐藏）
        const icons = Object.values(this.connectionsMap).flat();
        const uniqueIcons = Array.from(new Set(icons));

        // 检查是否存在渐变定义，如果不存在则创建
        let gradient = svg.querySelector('#connection-gradient');
        if (!gradient) {
          const defs = document.createElementNS('http://www.w3.org/2000/svg', 'defs');
          gradient = document.createElementNS('http://www.w3.org/2000/svg', 'linearGradient');
          gradient.setAttribute('id', 'connection-gradient');
          gradient.setAttribute('x1', '0%');
          gradient.setAttribute('y1', '0%');
          gradient.setAttribute('x2', '0%');
          gradient.setAttribute('y2', '100%');
          
          const stop1 = document.createElementNS('http://www.w3.org/2000/svg', 'stop');
          stop1.setAttribute('offset', '0%');
          stop1.setAttribute('stop-color', '#ABD5FF');
          
          const stop2 = document.createElementNS('http://www.w3.org/2000/svg', 'stop');
          stop2.setAttribute('offset', '100%');
          stop2.setAttribute('stop-color', '#2466A8');
          
          gradient.appendChild(stop1);
          gradient.appendChild(stop2);
          defs.appendChild(gradient);
          svg.appendChild(defs);
        }

        uniqueIcons.forEach(iconClass => {
          const id = `conn-${iconClass}`;
          if (!svg.querySelector(`#${id}`)) {
            const p = document.createElementNS('http://www.w3.org/2000/svg', 'path');
            p.setAttribute('id', id);
            p.setAttribute('stroke', 'url(#connection-gradient)');
            p.setAttribute('stroke-width', '1');
            p.setAttribute('fill', 'none');
            p.style.display = 'none';
            svg.appendChild(p);
          }
        });

        // 首次绘制
        this.updateConnections();
        // 监听窗口尺寸变化
        window.addEventListener('resize', this.updateConnectionsBound = this.updateConnections.bind(this));
      });
    },

    /**
     * 更新连线位置
     */
    updateConnections() {
      const container = document.querySelector('.section-3-container');
      const svg = container && container.querySelector('.connections-svg');
      if (!container || !svg) return;

      // 同步 svg 尺寸为容器内容高度
      svg.style.position = 'absolute';
      svg.style.top = '0';
      svg.style.left = '0';
      svg.style.width = '100%';
      svg.style.height = `${container.scrollHeight}px`;
      svg.setAttribute('viewBox', `0 0 ${container.clientWidth} ${container.scrollHeight}`);

      const info = document.querySelector('.info_public');
      if (!info) {
        // 隐藏所有路径
        const allPaths = svg.querySelectorAll('path');
        allPaths.forEach(p => p.style.display = 'none');
        return;
      }

      const containerRect = container.getBoundingClientRect();
      const infoRect = info.getBoundingClientRect();

      // 判断两个 DOMRect 是否接近完全重叠（以较小矩形为基准，重叠面积 >= 99%）
      function rectsFullyOverlap(a, b) {
        const ix = Math.max(0, Math.min(a.right, b.right) - Math.max(a.left, b.left));
        const iy = Math.max(0, Math.min(a.bottom, b.bottom) - Math.max(a.top, b.top));
        const inter = ix * iy;
        const areaA = (a.right - a.left) * (a.bottom - a.top);
        const areaB = (b.right - b.left) * (b.bottom - b.top);
        const minArea = Math.min(areaA, areaB);
        if (minArea <= 0) return false;
        return inter >= minArea * 0.99;
      }
      
      // 计算目标点（info_public 左侧中点）
      const xi = infoRect.left - containerRect.left + container.scrollLeft; // info_public 左侧
      const yi = infoRect.top - containerRect.top + (infoRect.height / 2) + container.scrollTop;

      // 要显示的图标列表由当前 this.itemIndex 决定
      const activeIcons = this.connectionsMap[this.itemIndex] || [];

      // 遍历所有已创建的 path（基于 connectionsMap 的 union），更新显示/隐藏
      const allIcons = Object.values(this.connectionsMap).flat();
      const uniqueIcons = Array.from(new Set(allIcons));
      let hasFullyOverlapped = false;
      uniqueIcons.forEach(iconClass => {
        const iconEl = document.querySelector(`.${iconClass}`);
        const pathEl = svg.querySelector(`#conn-${iconClass}`);
        if (!pathEl) return;

        if (!iconEl) {
          pathEl.style.display = 'none';
          pathEl.setAttribute('d', '');
          return;
        }

        const iconRect = iconEl.getBoundingClientRect();
        // 目标 native 图标 class 规则：icon7 -> icon1_7
        const num = iconClass.replace('icon', '');
        const targetClass = `icon1_${num}`;
        const targetEl = document.querySelector(`.${targetClass}`);
        const targetRect = targetEl ? targetEl.getBoundingClientRect() : null;

        // 只有当该 icon 在当前选中列表且与其 native 完全重叠时才显示连线
        if (activeIcons.includes(iconClass) && targetRect && rectsFullyOverlap(iconRect, targetRect)) {
          // 标记存在完全重叠的图标
          hasFullyOverlapped = true;
          // 起点在 icon 右侧，垂直居中；终点为 info 左侧中点
          const sx = iconRect.right - containerRect.left + container.scrollLeft;
          const sy = iconRect.top - containerRect.top + (iconRect.height / 2) + container.scrollTop;
          const midX = (sx + xi) / 2;
          const ctrlY = Math.min(sy, yi) - 120;
          const path = `M ${sx} ${sy} Q ${midX} ${ctrlY} ${xi} ${yi}`;
          pathEl.setAttribute('d', path);
          pathEl.style.display = 'block';
          // 将 icon 置于上层，native 置于下层
          try {
            iconEl.style.zIndex = '30';
            if (targetEl) targetEl.style.zIndex = '20';
          } catch (e) {}
        } else {
          pathEl.setAttribute('d', '');
          pathEl.style.display = 'none';
          // 非激活或未完全重叠时，将 native 置于上层，icon 置于下层（恢复默认样式可用空字符串）
          try {
            iconEl.style.zIndex = '10';
            if (targetEl) targetEl.style.zIndex = '40';
          } catch (e) {}
        }
      });

      // 循环结束后统一设置 svg 的 zIndex
      svg.style.zIndex = hasFullyOverlapped ? '50' : '';
    },
    
    /**
     * 实时处理第三屏内部滚动（用于动画）
     */
    handleSection3ScrollRealTime() {
      const section3Container = document.querySelector('.section-3-container');
      if (!section3Container) return;
      
      const scrollTop = section3Container.scrollTop;
      const clientHeight = section3Container.clientHeight;
      const scrollHeight = section3Container.scrollHeight;
      this.$emit('section-3-scroll-top-change', scrollTop);
      
      // 计算滚动进度
      const maxScroll = scrollHeight - clientHeight;
      if (maxScroll > 0) {
        this.scrollProgress = Math.min(scrollTop / maxScroll, 1);
        this.updateIconAnimation();
      } else {
        this.scrollProgress = 0;
        this.resetIconPosition();
      }
    },
    
    /**
     * （已移除，使用下面的通用 resetIconPosition）
     */
    
    /**
     * 更新图标动画
     */
    updateIconAnimation() {
      // 获取图标元素
      const iconPairs = [
        { initial: { top: 217, left: 200 }, target: { top: 1505, left: 210 }, className: 'icon1', targetClassName: 'icon1_1' },
        { initial: { top: 240, left: 575 }, target: { top: 1418, left: 385 }, className: 'icon2', targetClassName: 'icon1_2' },
        { initial: { top: 484, left: 330 }, target: { top: 1680, left: 210 }, className: 'icon3', targetClassName: 'icon1_3' },
        { initial: { top: 665, left: 575 }, target: { top: 1593, left: 385 }, className: 'icon4', targetClassName: 'icon1_4' },
        { initial: { top: 815, left: 200 }, target: { top: 1855, left: 210 }, className: 'icon5', targetClassName: 'icon1_5' },
        { initial: { top: 700, left: 1085 }, target: { top: 1768, left: 385 }, className: 'icon6', targetClassName: 'icon1_6' }, // right: 535, width: 150 -> left: 1920-535-150=1370
        { initial: { top: 850, left: 1395}, target: { top: 1943, left: 385 }, className: 'icon7', targetClassName: 'icon1_7' }, // right: 275, width: 200 -> left: 1920-275-200=1412
        { initial: { top: 675, left: 1550 }, target: { top: 1680, left: 560 }, className: 'icon8', targetClassName: 'icon1_8' }, // right: 50, width: 200 -> left: 1920-50-200=1670
        { initial: { top: 340, left: 1285 }, target: { top: 1505, left: 560 }, className: 'icon9', targetClassName: 'icon1_9' }, // right: 308, width: 200 -> left: 1920-308-200=1412
        { initial: { top: 175, left: 1460 }, target: { top: 1855, left: 560 }, className: 'icon10', targetClassName: 'icon1_10' }  // right: 200, width: 150 -> left: 1920-200-150=1570
      ];
      
      // 遍历每个图标对并更新其位置
      iconPairs.forEach(pair => {
        const icon = document.querySelector(`.${pair.className}`);
        const targetIcon = document.querySelector(`.${pair.targetClassName}`);
        
        if (!icon || !targetIcon) return;
        // 从 DOM 获取实际尺寸，避免硬编码导致的偏差
        const iconRect = icon.getBoundingClientRect();
        const targetRect = targetIcon.getBoundingClientRect();
        const initialWidth = iconRect.width;
        const targetSize = targetRect.width;

        // 计算差值并根据进度（带速度乘数）计算当前位置
        const topDiff = pair.target.top - pair.initial.top;
        const leftDiff = pair.target.left - pair.initial.left;
        const animationSpeedMultiplier = 2.25; // 增加动画速度倍数
        const progress = Math.min(this.scrollProgress * animationSpeedMultiplier, 1);

        const currentTop = pair.initial.top + (topDiff * progress);
        const currentLeft = pair.initial.left + (leftDiff * progress);
        const currentSize = initialWidth + ((targetSize - initialWidth) * progress);

        // 限制范围防止超出原始目标位置和目标尺寸
        const boundedTop = Math.min(Math.max(currentTop, Math.min(pair.initial.top, pair.target.top)), Math.max(pair.initial.top, pair.target.top));
        const boundedLeft = Math.min(Math.max(currentLeft, Math.min(pair.initial.left, pair.target.left)), Math.max(pair.initial.left, pair.target.left));
        const boundedSize = Math.min(Math.max(currentSize, Math.min(initialWidth, targetSize)), Math.max(initialWidth, targetSize));

        // 直接操作DOM元素，宽高使用像素并限制到目标范围
        icon.style.position = 'absolute';
        icon.style.top = `calc(100vh * ${boundedTop} / 1080)`;
        icon.style.left = `calc(100vw * ${boundedLeft} / 1920)`;
        icon.style.width = `${Math.round(boundedSize)}px`;
        icon.style.height = `${Math.round(boundedSize)}px`;
        icon.style.transition = 'none';
        icon.style.zIndex = '10';
        // 强制浏览器重排
        icon.offsetHeight;
      });
    },
    
    /**
     * 重置图标到原始位置
     */
    resetIconPosition() {
      // 重置所有图标到原始CSS样式
      for (let i = 1; i <= 10; i++) {
        const icon = document.querySelector(`.icon${i}`);
        if (icon) {
          icon.style.position = '';
          icon.style.top = '';
          icon.style.left = '';
          icon.style.width = '';
          icon.style.height = '';
          icon.style.transition = '';
          icon.style.transform = '';
          icon.style.transformOrigin = '';
          icon.style.zIndex = '';
        }
      }
    },

    /**
     * 清理函数
     */
    cleanup() {
      const section3Container = document.querySelector('.section-3-container');
      if (section3Container) {
        if (this._handleSection3ScrollRealTime) section3Container.removeEventListener('scroll', this._handleSection3ScrollRealTime);
        if (this._updateConnectionsForScroll) section3Container.removeEventListener('scroll', this._updateConnectionsForScroll);
      }
      // 移除 resize 监听
      if (this.updateConnectionsBound) {
        window.removeEventListener('resize', this.updateConnectionsBound);
        this.updateConnectionsBound = null;
      }
      this._handleSection3ScrollRealTime = null;
      this._updateConnectionsForScroll = null;
    }
  }
};
</script>

<style lang="scss" scoped>
// .connections-svg{
//   z-index: 41;
// }
.fullpage-container {
  width: 100%;
  height: 100vh;
  overflow: hidden;
  position: relative;
}

.fullpage-wrapper {
  width: 100%;
  height: 100%;
  transition: transform 1.5s ease-in-out;
  will-change: transform;
}

.fullpage-section {
  width: 100%;
  height: 100vh;
}

.section-content {
 position: relative;
 width: 100%;
 height: 100%;
}

.topBT{
  width: calc(100% * 1674 / 1920);
  height: calc(100% * 360 / 1080);
  position: absolute;
  top: calc(100% * 83 / 1080);
  left: 50%;
  transform: translate(-50%, 0);
  z-index: 2;
}

.section-1_top{
  width: 700px;
  max-height: calc(100vh - 225px);
  position: absolute;
  top: calc(100vh * 370 / 1080);
  left: 50%;
  transform: translate(-50%, 0);
  z-index: 3;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  .section-1_top_title{
    
    font-weight: 400;
    font-size: 48px;
    line-height: 150%;
    text-align: center;
    color: rgba(0, 0, 0, 1);
  }

  .section-1_top_desc{
    
    font-weight: 300;
    font-style: Light;
    font-size: 18px;
    line-height: 150%;
    text-align: center;
    color: rgba(0, 0, 0, 1);
    margin-top: 20px;
  }
  
  .section-1_top_btn{
    width: 180px;
    height: 46px;
    border-radius: 100px;
    background: #fff;
    margin-top: 30px;
    display: flex;
    justify-content: center;
    align-items: center;

    .section-1_top_btn_item{
      width: 174px;
      height: 40px;
      display: flex;
      justify-content: center;
      align-items: center;
      
      font-weight: 400;
      font-style: Regular;
      font-size: 18px;
      color: rgba(0, 0, 0, 1);
      cursor: pointer;
      background: linear-gradient(270deg, #95D9C1 0%, #47789E 100%);
      color: #fff;
      font-weight: 700;
      font-style: Bold;
      border-radius: 100px;
    }
  }
}

.section-1_bottom{
  height: calc(100vh * 412 / 1080);
  left: calc(100vw * 210 / 1920);
  bottom: 0;
  width: calc(100vw * 1500 / 1920);
  position: absolute;
  z-index: 5;
  border-top-left-radius: 25px;
  border-top-right-radius: 25px;
  border: 1px solid rgba(255, 255, 255, 0.5);
  backdrop-filter: blur(10px);
  display: flex;
  justify-content: center;
  align-items: self-end;

  .section-1_bottom_img{
    width: calc(100vw * 1490 / 1920);
    height: calc(100vh * 407 / 1080);
  }
}

/* 各屏背景色 */
.section-1 {
  background: url(../../assets/img/home/back_2.png);
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  position: relative;

  .section-content_1{
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
}

.section-3 {
  height: 100vh;
  position: relative;
  overflow: hidden;

  .section-3-container {
    width: 100%;
    height: 100vh;
    transition: all 0.3s ease;
    overflow-y: auto;
    overflow-x: hidden;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 2;
    -webkit-overflow-scrolling: touch;
    scroll-behavior: auto;
    scrollbar-width: none;
    -ms-overflow-style: none;
    min-height: 100vh;

    &.scrollable {
      overflow-y: auto!important;
      overflow-x: hidden;
      height: 100vh;
    }

    &::-webkit-scrollbar {
      display: none;
    }
     
    .section-3-content{
      width: 100%;
      margin-bottom: 40px;
      // background: rgba(0, 0, 0, 1);

      .section-3-content_1{
        width: 100%;
        overflow: hidden;
        position: relative;

        .section-3-content_1_back{
          position: absolute;
          top: calc(100vh * 245 / 1080);
          left: 50%;
          transform: translate(-50%, 0);
          width: calc(100vw * 1743 / 1920);
          height: calc(100vh * 1940 / 1080);
          background: url(../../assets/img/home/section-3-content_1_backImg.png) no-repeat center center;
          background-size: 100% 100%;
        }

        :deep(.icon-overlay){
          position: absolute;
          width: 300px;
          min-height: 300px;
          padding: 26px 28px;
          box-sizing: border-box;
          background: url(../../assets/img/home/icon-overlay.png) no-repeat center center;
          background-size: 100% 100%;
          pointer-events: none;
          display: none;
          z-index: 100;
          border-radius: 20px;
          transform: translate(-50%, -50%);
          justify-content: center;
          align-items: center;
        }

        :deep(.icon-overlay.visible){
          display: flex;
        }

        :deep(.icon-overlay-content){
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: flex-start;
          gap: 8px;
          width: 100%;
          color: #ffffff;
        }

        :deep(.icon-overlay-title){
          font-size: 22px;
          font-weight: 700;
          line-height: 1.4;
          color: rgb(0, 0, 0);
        }

        :deep(.icon-overlay-desc){
          font-size: 15px;
          line-height: 1.6;
          color: rgb(0, 0, 0);
        }

        .icon1{
          position: absolute;
          top: calc(100vh * 217 / 1080);
          left: calc(100vw * 200 / 1920);
          width: 100px;
          height: 100px;
          cursor: pointer;
        }

        .icon2{
          position: absolute;
          top: calc(100vh * 240 / 1080);
          left: calc(100vw * 575 / 1920);
          width: 150px;
          height: 150px;
          cursor: pointer;
        }

        .icon3{
          position: absolute;
          top: calc(100vh * 484 / 1080);
          left: calc(100vw * 330 / 1920);
          width: 200px;
          height: 200px;
          cursor: pointer;
        }

        .icon4{
          position: absolute;
          top: calc(100vh * 665 / 1080);
          left: calc(100vw * 575 / 1920);
          width: 100px;
          height: 100px;
          cursor: pointer;
        }

        .icon5{
          position: absolute;
          top: calc(100vh * 815 / 1080);
          left: calc(100vw * 200 / 1920);
          width: 150px;
          height: 150px;
          cursor: pointer;
        }

        .icon6{
          position: absolute;
          top: calc(100vh * 700 / 1080);
          right: calc(100vw * 685 / 1920);
          width: 150px;
          height: 150px;
          cursor: pointer;
        }

        .icon7{
          position: absolute;
          top: calc(100vh * 850 / 1080);
          left: calc(100vw * 1395 / 1920);
          width: 100px;
          height: 100px;
          cursor: pointer;
        }

        .icon8{
          position: absolute;
          top: calc(100vh * 675 / 1080);
          right: calc(100vw * 165 / 1920);
          width: 200px;
          height: 200px;
          cursor: pointer;
        }

        .icon9{
          position: absolute;
          top: calc(100vh * 340 / 1080);
          right: calc(100vw * 435 / 1920);
          width: 200px;
          height: 200px;
          cursor: pointer;
        } 

        .icon10{
          position: absolute;
          top: calc(100vh * 175 / 1080);
          right: calc(100vw * 310 / 1920);
          width: 150px;
          height: 150px;
          cursor: pointer;
        }

        .icon1_1{  
          position: absolute;
          top: calc(100vh * 1505 / 1080);
          left: calc(100vw * 210 / 1920);
          width: 150px;
          height: 150px;
        }

        .icon1_2{
          position: absolute;
          top: calc(100vh * 1418 / 1080);
          left: calc(100vw * 385 / 1920);
          width: 150px;
          height: 150px;
        }

        .icon1_3{
          position: absolute;
          top: calc(100vh * 1680 / 1080);
          left: calc(100vw * 210 / 1920);
          width: 150px;
          height: 150px;
        }

        .icon1_4{
          position: absolute;
          top: calc(100vh * 1593 / 1080);
          left: calc(100vw * 385 / 1920);
          width: 150px;
          height: 150px;
        }

        .icon1_5{
          position: absolute;
          top: calc(100vh * 1855 / 1080);
          left: calc(100vw * 210 / 1920);
          width: 150px;
          height: 150px;
        }

        .icon1_6{
          position: absolute;
          top: calc(100vh * 1768 / 1080);
          left: calc(100vw * 385 / 1920);
          width: 150px;
          height: 150px;
        }

        .icon1_7{
          position: absolute;
          top: calc(100vh * 1943 / 1080);
          left: calc(100vw * 385 / 1920);
          width: 150px;
          height: 150px;
        }
        
        .icon1_8{
          position: absolute;
          top: calc(100vh * 1680 / 1080);
          left: calc(100vw * 560 / 1920);
          width: 150px;
          height: 150px;
        }

        .icon1_9{
          position: absolute;
          top: calc(100vh * 1505 / 1080);
          left: calc(100vw * 560 / 1920);
          width: 150px;
          height: 150px;
        }

        .icon1_10{
          position: absolute;
          top: calc(100vh * 1855 / 1080);
          left: calc(100vw * 560 / 1920);
          width: 150px;
          height: 150px;
        }

        .info_view{
          position: absolute;
          top: calc(100vh * 1509 / 1080);
          right: calc(100vw * 130 / 1920);
          width: calc(100vw * 830 / 1920);
          height: auto;
          // background: #95D9C1;
          display: grid;
          grid-template-rows: repeat(5, auto);
          gap: 20px;
          z-index: 51;

          .info_view_item{
            background: rgba(245, 245, 247, 1);
            // min-height: calc(100vh * 50 / 1080);
            // height: auto;
            height: max-content;
            padding:10px 18px;
            font-weight: 400;
            width: max-content;
            font-size: 20px;
            color: rgba(0, 0, 0, 1);
            border-radius: 25px;
            cursor: pointer;
            display: flex;
            align-items: center;

            .info_view_item_view{
              width: calc(100vw * 830 / 1920);
              // height: calc(100vh * 240 / 1080);
              border-radius: 25px;
              background: rgba(245, 245, 247, 1);
              
              font-size: 20px;
              line-height: 150%;
              letter-spacing: 0%;
              color: rgba(0, 0, 0, 1);

              span{
                font-weight: 700;
              }
            }

            img{
              width: 30px;
              height: 30px;
              margin-right: 10px;
            }
          }
        }

        .section-3-content_1_t{
          width: 100%;
          height: 100vh;
          background: linear-gradient(180deg, #DFF6FA 0%, #F5F5F7 50%, #FFFFFF 100%);
          display: flex;
          justify-content: center;
          align-items: center;
          flex-direction: column;

          .section-3-content_1_t_title{
            
            font-weight: 700;
            font-size: 48px;
            line-height: 150%;
            text-align: center;
            color: rgba(0, 0, 0, 1);
          }

          .section-3-content_1_t_desc{
            
            font-weight: 300;
            font-style: Light;
            font-size: 16px;
            line-height: 150%;
            text-align: center;
            color: rgba(0, 0, 0, 1);
          }

          .section-3-content_1_t_img{
            width: calc(100vw * 453 / 1920);
            height: calc(100vh * 40 / 1080);
            margin-top: 20px;
          }
        }

        .section-3-content_1_b{
          width: 100%;
          height: 100vh;
          display: flex;
          align-items: center;
          flex-direction: column;

          .section-3-content_1_b_title{
            
            font-weight: 700;
            font-size: 48px;
            line-height: 150%;
            color: rgba(0, 0, 0, 1);
          }
        }
      }

      .section-3-content_2{
        width: 100%;
        height: 718px;
        display: flex;
        background: #fff;
        margin-top: 312px;

        .section-3-content_2_img{
          width: 956px;
          height: 718px;
        }

        .section-3-content_2_r{
          display: flex;
          flex-direction: column;

          .section-3-content_2_r_title{
            
            font-weight: 700;
            font-style: Bold;
            font-size: 48px;
            line-height: 150%;
            color: rgba(0, 0, 0, 1);
          }

          .section-3-content_2_r_view{
            width: 100%;
            height: 100px;
            gap: 30px;
            display: flex;
            margin-top: 122px;
            margin-bottom: 20px;
            z-index: 50;

            .section-3-content_2_r_view_item{
              width: 100px;
              height: 100px;
              background: radial-gradient(100% 100% at 50% 100%, #F5F5F7 0%, #F1F1F1 100%);
              border-radius: 15px;
              display: flex;
              justify-content: center;
              align-items: center;
              cursor: pointer;

              .section-3-content_2_r_view_item_img{
                width: 50px;
                height: 50px;
              }

              .section-3-content_2_r_view_item_img_other{
                width: 62px;
                height: 50px;
              }
            }

            .active{
              background: linear-gradient(180deg, #ABD5FF 0%, #2466A8 100%);
            }
          }

          .section-3-content_2_r_text1{
            
            font-weight: 700;
            font-style: Bold;
            font-size: 28px;
            line-height: 150%;
            color: rgba(0, 0, 0, 1);
          }

          .section-3-content_2_r_text2{
            
            font-weight: 400;
            font-style: Regular;
            font-size: 24px;
            line-height: 150%;
            max-width: 500px;
            color: rgba(0, 0, 0, 1);
          }
        }
      }

      .section-3-content_3{
        width: 100%;
        display: flex;
        align-items: center;
        flex-direction: column;
        // background: #F5F5F7;

        .section-3-content_3_title{
          
          font-weight: 700;
          font-style: Bold;
          font-size: 48px;
          line-height: 100%;
          color: rgba(64, 64, 64, 1);
          margin-top: 120px;
        }

        .section-3-content_3_img_view{
          width: 912px;
          height: 350px;
          margin-top: 40px;

          .section-3-content_3_img_view_img{
            width: 100%;
            height: 100%;
          }
        }

        .section-3-content_3_btn{
          width: 1000px;
          height: 405px;
          border-radius: 24px;
          display: flex;
          justify-content: center;
          align-items: center;
          background: rgba(245, 245, 247, 1);
          margin: 300px auto 265px;

          .section-3-content_3_btn_l{
            width: 365px;
            height: 215px;
            cursor: pointer;
          }

          .section-3-content_3_btn_r{
            width: 450px;
            height: 245px;
          }

          .section-3-content_3_btn_img{
            width: 100%;
            height: 100%;
          }
        }
      }
    }
  }
}
</style>